(function () {
  if (window.BKSearchDeferredLoaded) return;
  window.BKSearchDeferredLoaded = true;

  const search = window.BlsSearchShopify;
  if (!search) return;

  search.resultCache = search.resultCache || {};
  search.abortController = null;

  search.isSearchOpen = function () {
    return (
      document.documentElement.classList.contains("open-search") ||
      Boolean(
        document.querySelector(
          "#search-form.bls__opend-popup-header, .popup-search-show, .bls__canvas.bls__opend-popup, .bls__canvas.is-open"
        )
      )
    );
  };

  search.resetPredictiveResults = function (clearInput) {
    const input = document.querySelector('input[type="search"]');
    const predictiveSearch = document.querySelector("#predictive-search");
    const quickSearch = document.querySelector("#quick-search");
    const container = document.querySelector("[data-predictive-search]");

    if (clearInput && input) input.value = "";
    if (input) {
      input.setAttribute("aria-expanded", "false");
      input.setAttribute("aria-activedescendant", "");
    }
    if (predictiveSearch) predictiveSearch.classList.remove("results", "loading");
    if (quickSearch) quickSearch.classList.remove("d-none");
    if (container) container.innerHTML = "";
    this.isOpen = false;
  };

  search.onChange = function () {
    const query = this.getQuery();
    if (query.length < 2 || !this.isSearchOpen()) {
      this.resetPredictiveResults(false);
      return;
    }

    this.getSearchResults(query);
  };

  search.onFocus = function () {
    const query = this.getQuery();
    if (query.length < 2 || !this.isSearchOpen()) return;

    if (document.querySelector("#predictive-search")?.classList.contains("results")) {
      this.open();
    } else {
      this.getSearchResults(query);
    }
  };

  search.onKeyup = function (event) {
    if (this.getQuery().length < 2) {
      this.resetPredictiveResults(false);
      return;
    }

    switch (event.code) {
      case "ArrowUp":
        event.preventDefault();
        this.switchOption("up");
        break;
      case "ArrowDown":
        event.preventDefault();
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  };

  search.onFormSubmit = function (event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  };

  search.getSearchResults = function (query) {
    const cacheKey = query.replace(/\s+/g, "-").toLowerCase();

    if (this.resultCache[cacheKey]) {
      this.renderSearchResults(this.resultCache[cacheKey]);
      return;
    }

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    const isPopup = document.querySelector(".search_type_popup");
    const sectionId = isPopup ? "search-predictive-grid" : "search-predictive-list";
    const isSuggestMode = document.querySelector(".predictive_search_suggest");
    const endpoint = isSuggestMode ? routes?.predictive_search_url : routes.search_url;
    const url = isSuggestMode
      ? `${endpoint}?q=${encodeURIComponent(
          query
        )}&resources[type]=product,page,article,query,collection&section_id=${sectionId}`
      : `${endpoint}?q=${encodeURIComponent(
          query
        )}&resources[type]=product,page,article,query,collection&section_id=${sectionId}`;

    this.setLiveRegionLoadingState();

    fetch(url, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const section = doc.querySelector(`#shopify-section-${sectionId}`);
        const markup = section?.innerHTML || "";

        if (!markup) throw new Error("Empty predictive search response");

        this.resultCache[cacheKey] = markup;
        this.renderSearchResults(markup);
        window.BlsColorSwatchesShopify?.init?.();
        window.BlsLazyloadImg?.init?.();
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        console.warn("Predictive search failed", error);
        this.resetPredictiveResults(false);
      });
  };
})();
